import { message, Popconfirm } from 'antd';
import {SActionBtn, SMessage} from "shj-components";
import {ticketsAccept, ticketsAnewOpen, ticketsIssuePushComment} from "@/services/customerServices.ts";

/**
 * 受理
 */
export const WorkerOrderAccept = (props: any) => {
  const { id, fn, auth } = props;
  const workerOrderAcceptFn = (id: any) => {
    SMessage.confirm({
      title: '确认受理？',
      content: null,
      onOk: () => {
        return ticketsAccept(id).then((resp: any) => {
          message.success(resp.message || '操作成功');
          fn && fn();
        })
      },
    })
  };
  return ( <SActionBtn auth={auth} onClick={() => workerOrderAcceptFn(id)}>受理</SActionBtn>);
};

/**
 * 确认推送评价
 */
export const PushIssueComment = (props: any) => {
  const { id, issueId, fn, auth } = props;
  const pushIssueComment = (issueId: any) => {
    SMessage.confirm({
      title: '确认推送？',
      content: null,
      onOk: () => {
        return ticketsIssuePushComment({id: issueId}).then((resp: any) => {
          message.success(resp.message || '操作成功');
          fn && fn();
        })
      },
    })
  }

  return (
      <SActionBtn auth={auth} onClick={() => pushIssueComment(issueId)}>推送评价</SActionBtn>
  );
};

/**
 * 重新打开
 */
export const AnewOpenWorkerOrder = (props: any) => {
  const { id, fn, auth } = props;
  // 重新打开
  const anewOpenWorkerOrder = (id: any) => {
    SMessage.confirm({
      title: '确认重新打开？',
      content: null,
      onOk: () => {
        return ticketsAnewOpen(id).then((resp: any) => {
          message.success(resp.message || '操作成功');
          fn && fn();
        })
      },
    });
  };
  return (
      <SActionBtn auth={auth} onClick={() => anewOpenWorkerOrder(id)}>重新打开</SActionBtn>
  );
};
